import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuthState, useAuthDispatch, checkSession } from "../Context";
import LoadingPage from "./Loading/Loading";
import Box from "@mui/material/Box";


const PrivateRoute = ({ children }) => {

  const dispatch = useAuthDispatch();
	const { isAuthenticated, activePath } = useAuthState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // Track if component is still mounted
    const verifySession = async () => {
      try {
        console.log("checking session");
        await checkSession(dispatch);
        if (isMounted) {
          console.log("session verified");
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          console.log(error.message);
          setLoading(false);
        }
      }
    };
    

    verifySession();
    return () => {
      isMounted = false; // Set it to false when the component unmounts
    };
  }, [dispatch, activePath]);
  // console.log("loading?", loading)

   // If loading is true, then return a loading message or a spinner
   if (loading) {
    return (
      <Box
        sx={{
          alignItems: "center",
          justifyContent: "center",
          position: "fixed", // The element is positioned relative to the browser window
          top: "50%", // Move it down to 50% of the height
          left: "50%", // Move it right to 50% of the width
          transform: "translate(-50%, -50%)", // This is to offset the spinner's own height and width
        }}
      >
        <LoadingPage />
      </Box>
    );
  }

  // console.log("isAuthenticated?", isAuthenticated)
  // console.log("userAttributes", userAttributes)
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
